import { AcceleratorsEmpty } from './AcceleratorsEmptyIllustration'
import { ActivitiesEmpty } from './ActivitiesEmptyIllustration'
import { Birthday } from './BirthdayIllustration'
import { ChampionIllustration as Champion } from './ChampionIllustration'
import { ChasingMoneyIllustration as ChasingMoney } from './ChasingMoneyIllustration'
import { ContactEmptyIllustration as ContactEmpty } from './ContactEmptyIllustration'
import { ContactIllustration as Contact } from './ContactIllustration'
import { ContentEmpty } from './ContentEmptyIllustration'
import { ContentEmptyState } from './ContentEmptyStateIllustration'
import { DataOrganizationEmpty } from './DataOrganizationEmptyIllustration'
import { DeleteItem } from './DeleteItem'
import { Done } from './DoneIllustrantion'
import { EmailConfirmed } from './EmailConfirmedIllustration'
import { EmailNotConfirmed } from './EmailNotConfirmedIllustration'
import { EmailResend } from './EmailResend'
import { EmailSent } from './EmailSent'
import { EvaluationSuccess } from './EvaluationSuccessllustration'
import { Fallback } from './FallbackIllustration'
import { Farewell } from './FarewellIllustration'
import { FavoriteContactsEmpty } from './FavoriteContactsEmptyIllustration'
import { FirstLoginSuccesfullyIllustration as FirstLoginSuccesfully } from './FirstLoginSuccesfullyIllustration'
import { GetJobPromotionIllustration as GetJobPromotion } from './GetJobPromotionIllustration'
import { GoodByeIcon as GoodBye } from './GoodByeIcon'
import { LaboritIllustration as Laborit } from './LaboritIllustration'
import { LoginAccountReviewIllustration as LoginAccountReview } from './LoginAccountReviewIllustration'
import { LoginBlocked } from './LoginBlockedIllustration'
import { LogoTabBar } from './LogoTabBarIllustration'
import { NoNotifications } from './NoNotificationsIllustration'
import { NoWalletTabs as NoWalletTabsIllustration } from './NoWalletTabsIllustrarion'
import { OnlineLearningIllustration as OnlineLearning } from './OnlineLearningIllustration'
import { PageErrorOccurred } from './PageErrorOccurredIllustration'
import { PageNoConnection } from './PageNoConnectionIllustration'
import { PageNotFound } from './PageNotFoundIllustration'
import { RecoveryPasswordSuccessfullyIllustration as RecoveryPasswordSuccesfully } from './RecoveryPasswordSuccesfullyIllustration'
import { RefuseTerms } from './RefuseTermsIllustration'
import { RelatedOpportunitiesEmpty } from './RelatedOpportunitiesEmptyIllustration'
import { ReSentCode } from './ReSentCodeIllustration'
import { ReSentEmail } from './ReSentEmailIllustration'
import { Search } from './SearchIllustration'
import { SearchNotFound } from './SearchNotFoundIllustration'
import { SocialMediaIllustration as SocialMedia } from './SocialMediaIllustration'
import { SuccessfulBusinessIllustration as SuccessfulBusiness } from './SuccessfulBusinessIllustration'
import { TimeInForWork } from './TimeInForWorkIllustration'
import { Trash } from './TrashIllustration'
import { Work } from './WorkIllustration'
import { WorkLifeBalanceIllustration as WorkLifeBalance } from './WorkLifeBalanceIllustration'

export default {
  AcceleratorsEmpty,
  ActivitiesEmpty,
  Birthday,
  ChasingMoney,
  ContactEmpty,
  ContentEmpty,
  ContentEmptyState,
  DataOrganizationEmpty,
  DeleteItem,
  Done,
  Search,
  SearchNotFound,
  EmailConfirmed,
  EmailNotConfirmed,
  EmailSent,
  EvaluationSuccess,
  RecoveryPasswordSuccesfully,
  ReSentEmail,
  SuccessfulBusiness,
  Farewell,
  Fallback,
  FavoriteContactsEmpty,
  GetJobPromotion,
  GoodBye,
  Contact,
  WorkLifeBalance,
  OnlineLearning,
  PageErrorOccurred,
  PageNoConnection,
  PageNotFound,
  LoginBlocked,
  EmailResend,
  FirstLoginSuccesfully,

  Trash,
  Laborit,
  LogoTabBar,
  LoginAccountReview,
  Work,
  SocialMedia,
  RefuseTerms,
  RelatedOpportunitiesEmpty,
  ReSentCode,
  NoNotifications,
  NoWalletTabsIllustration,
  TimeInForWork,
  Champion
}
